import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);

let hasReloadedForChunkError = false;

function shouldReloadForChunkError(message: string, filename?: string): boolean {
  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Loading chunk') ||
    filename?.includes('chunk-') === true
  );
}

// Runtime JS load errors
window.addEventListener('error', (event: ErrorEvent) => {
  const message = event?.message || '';
  const filename = event?.filename || '';

  if (
    !hasReloadedForChunkError &&
    shouldReloadForChunkError(message, filename)
  ) {
    hasReloadedForChunkError = true;
    console.warn('⚠️ Chunk load failed. Reloading application...');
    window.location.reload();
  }
});

// ✅ Handle failed dynamic imports (unhandled promise rejections)
window.addEventListener(
  'unhandledrejection',
  (event: PromiseRejectionEvent) => {
    const reason = event.reason || {};
    const message = reason?.message || reason?.toString() || '';

    const isChunkLoadFailed =
      message.includes('Loading chunk') ||
      message.includes('Failed to fetch dynamically imported module') ||
      message.includes('chunk-');

    if (isChunkLoadFailed) {
      console.warn(
        '⚠️ Chunk load failed (promise rejection). Reloading app...'
      );
      window.location.reload();
    }
  }
);
